var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.243,
    height: 27,
    viewBox: "0 0 33.243 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M29.826,10.11c.021.3.021.591.021.886,0,9.007-6.855,19.385-19.385,19.385A19.253,19.253,0,0,1,0,27.322a14.1,14.1,0,0,0,1.645.084A13.645,13.645,0,0,0,10.1,24.5a6.825,6.825,0,0,1-6.37-4.725,8.592,8.592,0,0,0,1.287.105,7.206,7.206,0,0,0,1.793-.232A6.814,6.814,0,0,1,1.35,12.957v-.084a6.862,6.862,0,0,0,3.08.865A6.823,6.823,0,0,1,2.32,4.625a19.366,19.366,0,0,0,14.048,7.13,7.691,7.691,0,0,1-.169-1.561A6.82,6.82,0,0,1,27.991,5.532a13.414,13.414,0,0,0,4.324-1.645,6.8,6.8,0,0,1-3,3.755,13.658,13.658,0,0,0,3.923-1.055,14.646,14.646,0,0,1-3.417,3.523Z",
    transform: "translate(0 -3.381)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.120a917cef412e03303e7bb9633343a1.svg";
export { ForwardRef as ReactComponent };